<template>
  <div>
    <md-table class="w-full min-w-[1200px]">
      <md-table-row>
        <md-table-head
          v-for="(header, index) in tableHeader"
          :key="index + 'header'"
        >
          {{ $t(header) }}
        </md-table-head>
      </md-table-row>
      <md-table-row
        v-for="(cell, index) in tableData"
        :key="index + 'tableBody'"
      >
        <md-table-cell>{{ index + 1 }}</md-table-cell>
        <md-table-cell>
          <span class="word-break-title">{{ cell.taskName }}</span>
        </md-table-cell>
        <md-table-cell>
          <span class="w-max inline-block">{{ cell.assignee }}</span>
        </md-table-cell>
        <md-table-cell>
          <span class="w-max inline-block">{{ cell.reviewer }}</span>
        </md-table-cell>
        <md-table-cell>
          <md-field v-if="hasStatus">
            <md-select
              v-model="cell.status"
              :disabled="
                getId(userInfo) !== cell.owner_id_no_sql &&
                  getId(userInfo) !== cell.assignee_id_no_sql &&
                  roleActive !== 'Admin' &&
                  roleActive !== 'Principal'
              "
              @md-selected="changeStatus(cell)"
            >
              <md-option
                v-for="(item, cellIndex) in filterStatus(cell.status)"
                :key="'selectOption' + index + cellIndex"
                :value="item.id"
              >
                {{ generateStatus(item.name) }}
              </md-option>
            </md-select>
          </md-field>
        </md-table-cell>
        <md-table-cell
          ><div class="min-w-[100px]">{{ cell.createTime }}</div></md-table-cell
        >
        <md-table-cell
          ><div class="min-w-[100px]">{{ cell.deadLine }}</div></md-table-cell
        >
        <md-table-cell>
          <div class="flex">
            <router-link :to="'/sub-task/' + cell.id">
              <md-button class="md-just-icon md-success md-simple table-action">
                <md-icon>edit</md-icon>
              </md-button>
            </router-link>
            <md-button
              class="md-just-icon md-danger md-simple table-action mx-1"
              @click="confirmDeleteSubtask(cell)"
              v-if="getId(userInfo) === cell.owner_id_no_sql"
            >
              <md-icon>close</md-icon>
            </md-button>
          </div>
        </md-table-cell>
      </md-table-row>
    </md-table>
    <div class="no-data" v-if="!tableData.length">
      {{ $t("task_management.no_data") }}
    </div>
  </div>
</template>
<script>
import { capitalizeFirstLetter, Message, getId } from "@/helpers/utils";
import { mapGetters } from "vuex";
import { service_names } from "@/constants/Services";
import Swal from "sweetalert2";
import { convertDateSendServer } from "@/helpers/datetime-helper";
import { generateStatus } from "../../../helpers/text-helper";

const roleActive = localStorage.getItem("roleActive");

export default {
  props: ["tableHeader", "tableData"],
  data() {
    return {
      generateStatus,
      roleActive,
      getId,
      capitalizeFirstLetter,
      taskStatus: {},
      hasStatus: false
    };
  },
  computed: {
    ...mapGetters("user", { userInfo: "info" })
  },
  created() {
    this.fetchStatus();
  },
  methods: {
    changeStatus(item) {
      Swal.fire({
        title: this.$t("common.are_you_sure"),
        text: this.$t("task_management.update_task_status"),
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "md-button md-success btn-fill",
        cancelButtonClass: "md-button md-raised btn-fill",
        confirmButtonText: this.$t("common.update"),
        buttonsStyling: false
      }).then(result => {
        if (result.value) {
          this.updateSubtask(item);
        } else {
          this.$emit("reloadData");
        }
      });
    },
    updateSubtask(item) {
      this.$axios
        .patch(`${service_names.school}/sub-task/${item.id}`, {
          task_status_id: item.status,
          task_name: item.task_name,
          deadline: convertDateSendServer(item.deadLine, "date"),
          assignee_id_no_sql: item.assignee_id_no_sql,
          description: item.description,
          file: item.file,
          owner_id_no_sql: item.owner_id_no_sql,
          reviewer_id_no_sql: item.reviewer_id_no_sql
        })
        .then(() => {
          Message.success(this.$t("common.update_success"));
          this.$emit("reloadData");
        })
        .catch(() => this.$emit("reloadData"));
    },
    fetchStatus() {
      this.$axios.get(`${service_names.school}/task-status`).then(res => {
        for (let i = 0; i < res.data.data.length; i++) {
          this.taskStatus[res.data.data[i].name] = res.data.data[i];
        }
        this.hasStatus = true;
      });
    },
    confirmDeleteSubtask(item) {
      Swal.fire({
        title: this.$t("common.are_you_sure"),
        text: this.$t("task_management.delete_title"),
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "md-button md-success btn-fill",
        cancelButtonClass: "md-button md-danger btn-fill",
        confirmButtonText: this.$t("common.yes_delete_it"),
        buttonsStyling: false
      }).then(result => {
        if (result.value) {
          this.deleteSubtask(item);
        }
      });
    },
    deleteSubtask(item) {
      this.$axios
        .delete(`${service_names.school}/sub-task/${item.id}`)
        .then(() => {
          Message.success(this.$t("common.delete_success"));
          this.$emit("reloadData");
        });
    },
    filterStatus(value) {
      if (
        value === this.taskStatus["assigned"].id ||
        value === this.taskStatus["in-progress"].id ||
        value === this.taskStatus.done.id
      ) {
        return [
          this.taskStatus["assigned"],
          this.taskStatus["in-progress"],
          this.taskStatus.done
        ];
      }
      if (value === this.taskStatus["re-open"].id) {
        return [
          this.taskStatus["re-open"],
          this.taskStatus["in-progress"],
          this.taskStatus.done
        ];
      }
      if (value === this.taskStatus.closes.id) {
        return [this.taskStatus.closes];
      }
      return [];
    }
  }
};
</script>
<style scoped lang="scss">
tr:nth-child(2n) {
  background-color: #f9f9f9;
}
tr:hover {
  background-color: #f5f5f5;
}
td {
  padding: 0 12px !important;
}
.no-data {
  border-top: 1px solid #d2d2d2;
  border-bottom: 1px solid #d2d2d2;
  padding: 12px 0;
  font-weight: 400;
  font-size: 16px;
  line-height: 19px;
  text-align: center;
  color: #000000;
}
</style>
